import React from "react";

export class TableReport extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        return (
            <>
                <table className="woocommerce-orders-table woocommerce-MyAccount-orders shop_table shop_table_responsive my_organization organization-table">
                    { this.props.table_columns.length > 0 ?
                        <thead>
                            <tr>
                                { this.props.table_columns.map( (elem:any, key:number) => {
                                    return <th key={key} className='woocommerce-orders-table__cell woocommerce-orders-table__cell-order-number' data-title={elem}>{elem}</th>
                                } ) }
                            </tr>
                        </thead>
                        : null
                    }
                    { this.props.table_rows.length > 0 ?
                        <tbody>
                        {this.props.table_rows.map((row:any, key:number) => {
                            return <tr key={key}>
                                {Object.entries(row).map(([sub_key, sub_value]: [string, any], index:number) => {
                                    return <td className="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-number" key={index}>{sub_value}</td>
                                })}
                            </tr>
                        })}
                        </tbody>
                        : null
                    }
                </table>
            </>
        )
    }
}